import { OrderStatus } from '../../entities/OrderStatus/OrderStatus';
import { OrderStatusResponseDTO } from '../../entities/OrderStatus/OrderStatusResponseDTO';

const OrderStatusResponseDTOtoOrderStatusAdapter = (response: OrderStatusResponseDTO): OrderStatus[] => {
  if (!response.body) {
    throw Error();
  }
  return response.body.orderStatuses.map(
    ({ serialNumber, description, shortDescription }) => new OrderStatus(serialNumber, description, shortDescription),
  );
};

export { OrderStatusResponseDTOtoOrderStatusAdapter };
